// Put your main mutations here
export default {
  updateMarkedRows: (state, payload) => {
    state.process.markedRows = payload;
  },
  increment: (state, payload) => {
    state.counter += payload;
  },
  decrement: (state) => {
    state.counter--;
  },

  auth_request(state) {
    state.status = "loading";
  },

  auth_error(state) {
    state.status = "error";
  },

  auth_success(state, payload) {
    state.status = "success";
    state.token = payload.token;
    state.user.ID_USUARIO = payload.usuario;
    state.user.scope = payload.scope;
    state.user.ID_CLIENTE = payload.id_client;
    state.user.USUARIO = payload.usuario;
    // state.user.IMAGE = "img/logos/" + payload.image;
    state.user.IMAGE = payload.logo;
    state.user.MENU = payload.menu_user;
    state.user.ACTIVO = payload.is_active;
    state.user.DIRECTOR = payload.is_director;
    state.user.STAFF = payload.is_staff;
    state.user.SUPERUSER = payload.is_superuser;
    state.user.proforma_type = payload.proforma_type;
    state.user.DETAILS = payload.client_details;
    state.user.waybill_custom_fields = payload.waybill_custom_fields;
    state.user.content_custom_fields = payload.content_custom_fields;
    state.user.customComponents = payload.custom_components;
  },

  logout(state) {
    state.status = "";
    state.token = "";
    state.user.ID_USUARIO = "";
    state.user.ID_CLIENTE = "";
    state.user.USUARIO = "";
    state.user.IMAGE = "";
    state.user.MENU = {};
    state.user.ACTIVO = false;
  },
  showOverlay(state) {
    state.overlay = true;
  },
  toggleOverlay(state) {
    state.show_overlay = !state.show_overlay;
  },
  hideOverlay(state) {
    state.overlay = false;
  },
  getCustomers: (state, payload) => {
    state.client_customers = payload;
  }
};
